import { render, staticRenderFns } from "./ReportRibbon.vue?vue&type=template&id=87a7cb64&scoped=true&"
import script from "./ReportRibbon.vue?vue&type=script&lang=js&"
export * from "./ReportRibbon.vue?vue&type=script&lang=js&"
import style0 from "./ReportRibbon.vue?vue&type=style&index=0&id=87a7cb64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a7cb64",
  null
  
)

export default component.exports